import { useCallback } from 'react';
import { Reference } from 'sr-types/lib/workflow/v1/graphql';
import { FETCH_POLICY_CONFIG } from '../../constants/constants';
import { useMutationWithContext } from '../../hooks/useMutationWithContext';
import { SaveApprovalMutationError, SaveApprovalServerError } from '../constants';
import { ApprovalInputViewModel } from '../types';
import { transformApprovalInputViewModelToWorkflowInput } from './utils';
import { saveWorkflowMutation, workflowGraphqlClient } from './workflowGraphqlApi';

export function useSaveApprovalInputApi() {
    const [saveWorkflow, { loading: isSavingApprovalInput }] = useMutationWithContext(
        saveWorkflowMutation,
        workflowGraphqlClient
    );

    const saveApprovalInputApi = useCallback(
        async (approvalData: ApprovalInputViewModel, initiate: boolean = false): Promise<Reference | null> => {
            const input = transformApprovalInputViewModelToWorkflowInput(approvalData);

            const mutationFetchResult = await saveWorkflow({
                variables: { input, initiate },
                fetchPolicy: FETCH_POLICY_CONFIG.apolloFetchPolicy,
                errorPolicy: 'all'
            });

            if (mutationFetchResult.errors?.length > 0) {
                throw new SaveApprovalMutationError(mutationFetchResult.errors[0].message);
            }

            if (mutationFetchResult.data?.saveWorkflow?.errors?.length > 0) {
                throw new SaveApprovalServerError(mutationFetchResult.data.saveWorkflow.errors[0].message);
            }

            return mutationFetchResult.data?.saveWorkflow?.reference ?? null;
        },
        [saveWorkflow]
    );

    return {
        saveApprovalInputApi,
        isSavingApprovalInput
    };
}
